export default __webpack_public_path__ + "static/media/quote-image.fda10561.png";